import Vue from 'vue'
import { $$ } from '../_utils'
import EventBus from '../_event-bus'

const ORDER_SEND_DATA_ENDPOINT = process.env.ORDER_SEND_DATA_ENDPOINT

Vue.component('vue-cart-info', {
  template: '#vue-cart-info-template',
  props: ['items', 'breakpoint', 'step', 'redirectPath'],
  data() {
    return {
      layout: '',
    }
  },
  methods: {
    addResizeListener() {
      EventBus.$on('resize', this.setLayout)
    },
    getViewportWidth() {
      return window.innerWidth
    },
    setLayout() {
      this.layout = this.getViewportWidth() <= this.$props.breakpoint ? 'mobile' : 'desktop'
    },
    handleSubmit() {
      if (this.$props.step == '1') window.location.replace(ORDER_SEND_DATA_ENDPOINT)
      else {
        EventBus.$emit('form-submit-btn-clicked', { submitted: true })
      }
    },
  },
  // created() {
  //   this.getUserForm()
  // },
  mounted() {
    this.setLayout()
    this.addResizeListener()
  },
})

const carts = $$('#vue-cart-info-wrapper')
window.addEventListener('load', () => {
  if (!carts) return
  carts.forEach(element => {
    new Vue({
      el: element,
    })
  })
})
